export default __webpack_public_path__ + "static/media/question-matrix.f51378fc.svg";